export default __webpack_public_path__ + "static/media/Headshot.1e5f0a06.jpg";